import axios from 'axios';

const authService = {
    getToken:
        () => {
            const AUTH_URL = `${authService.getAuthBasePath()}/connect/token`;

            const apiKey = process.env.REACT_APP_WEATHER_API_KEY;
            const secret = process.env.REACT_APP_WEATHER_API_SECRET;

            const params = new URLSearchParams();
            params.append('grant_type', process.env.REACT_APP_AUTH_GRANT_TYPE);
            params.append('scope', process.env.REACT_APP_AUTH_SCOPE);

            return axios.post(AUTH_URL, params, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                auth: {
                    username: apiKey,
                    password: secret
                }
            });
        },
    getServerUrl:
        () => {
            return `${window.location.protocol}//${window.location.host}/`;
        },
    getAuthBasePath:
        () => {
            return `${authService.getServerUrl()}${process.env.REACT_APP_AUTH_PATH}`;
        },
    getCaseManagerBasePath:
        () => {
            return `${authService.getServerUrl()}${process.env.REACT_APP_API_PATH}`;
        }

};

export default authService;
